import { PublicNav } from "@/components/layout/PublicNav";
import { Footer } from "@/components/layout/Footer";

export function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-[var(--aur-bg)]">
      <PublicNav />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
